<template>
  <div :class="jel_getClassObject(content)">
    <MediaImageFocalPoint
      :content="{
        formatRatio: '1x1',
        image: content.image,
        isBackground: true,
        altImage: content.altImage,
      }"
      class="overflow-hidden image-fond"
    >
    </MediaImageFocalPoint>
    <div class="images-supplementaires position-absolute d-flex align-items-center">
      <!-- bloc pour le logo -->
      <MediaImageFocalPoint
        v-if="content.image2"
        :content="{
          isLogo: true,
          formatRatio: '16x9',
          image: content.image2,
        }"
        class="overflow-hidden position-absolute image-logo image-centrale h-100 w-100"
      />
      <!-- bloc pour l'image de personnage -->
      <MediaImageFocalPoint
        v-else-if="content.image3"
        :content="{
          formatRatio: '1x1',
          image: content.image3,
        }"
        class="overflow-hidden position-absolute image-personnage h-100"
      />
    </div>
  </div>
</template>

<script>
import MediaImageFocalPoint from '@/components/media/image/MediaImageFocalPoint';

export default {
  name: 'MediaImageLogo',
  components: { MediaImageFocalPoint },
  props: { content: { type: Object, required: true } },
};
</script>

<style lang="scss" scoped>
div::v-deep div {
  width: inherit;
}

.image-fond::v-deep img {
  object-fit: cover;
}

.images-supplementaires {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  .image-centrale {
    ::v-deep a {
      height: auto !important;
      width: 100% !important;
    }
  }
}
@supports (-webkit-touch-callout: none) {
  .image-fond::v-deep img {
    width: 100%;
  }

  .image-personnage {
    height: 100%;
  }
}
@media not all and (min-resolution: 0.001dpcm) {
  @supports not (-webkit-touch-callout: none) {
    .image-fond::v-deep img {
      width: 100%;
    }
  }
}
</style>
